import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const PptxIcon = ({ color = '#e45d3c', text = 'PPTX', x = -2 }) => (
  <BaseFileIcon color={color} text={text} x={x} />
);

export default PptxIcon;
